require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-leading-the-way-how-code-fellows-is-innovating-cyber-education.json") })
        }
      }, "path---blog-leading-the-way-how-code-fellows-is-innovating-cyber-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-leading-the-way-how-code-fellows-is-innovating-cyber-education!./.cache/json/blog-leading-the-way-how-code-fellows-is-innovating-cyber-education.json
// module id = 935
// module chunks = 231608221292675